import { render, staticRenderFns } from "./EventRemovePage.vue?vue&type=template&id=5186386e"
import script from "./EventRemovePage.vue?vue&type=script&lang=js"
export * from "./EventRemovePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports